// extracted by mini-css-extract-plugin
export const address = "footer-module--address--e329f";
export const bottom = "footer-module--bottom--a4cf9";
export const brand = "footer-module--brand--254f2";
export const copy = "footer-module--copy--bcb19";
export const footer = "footer-module--footer--675c6";
export const grid = "footer-module--grid--793f5";
export const heading = "footer-module--heading--7b739";
export const inline = "footer-module--inline--32578";
export const list = "footer-module--list--59b0a";
export const mail = "footer-module--mail--facec";
export const mark = "footer-module--mark--d01b1";
export const members = "footer-module--members--3d64c";
export const partners = "footer-module--partners--c5a3a";
export const socials = "footer-module--socials--08018";
export const wordmark = "footer-module--wordmark--a19da";